import type React from 'react';

import { PaymentMethodIcon, PaymentMethodList } from '@change/ds-core-ui/PaymentMethod';
import { Text } from '@change/ds-core-ui/Text';

import { Translate } from '@change-corgi/core-react/i18n';

import { StripeCreditCardLayout } from '#src/app/shared/components/payments';

import { NameInputWrapper } from '../NameInputWrapper';
import { SubmitButton } from '../SubmitButton';

import { useStripeCreditCard } from './useStripeCreditCard';

// eslint-disable-next-line @change-ds/ds-no-raw-color-classname -- trademarked payment network logos need a white backing in both modes, per each network's brand guidelines
const LOGO_BACKING_CLASS = 'bg-white';

export const StripeCreditCard: React.FC<EmptyProps> = () => {
	const {
		data: { disabled, loading, ref, ...restData },
		actions,
	} = useStripeCreditCard();

	return (
		<div className="flex gap-3" data-testid="form-wrapper">
			<div className="elevation-elevated w-full rounded-lg p-5" data-qa="credit-card-form">
				<div className="flex items-center justify-between pb-4">
					<Text fontWeight="bold" ref={ref} tabIndex={-1}>
						<Translate value="corgi.co.promote.payment_type_button.card" />
					</Text>
					<PaymentMethodList>
						<PaymentMethodIcon type="visa" variant="card" className={LOGO_BACKING_CLASS} />
						<PaymentMethodIcon type="mastercard" variant="card" className={LOGO_BACKING_CLASS} />
						<PaymentMethodIcon type="discover" variant="card" className={LOGO_BACKING_CLASS} />
						<PaymentMethodIcon type="americanexpress" variant="card" className={LOGO_BACKING_CLASS} />
					</PaymentMethodList>
				</div>
				<div className="flex flex-col gap-4">
					<StripeCreditCardLayout
						{...restData}
						{...actions}
						layout="single"
						submitButton={<SubmitButton disabled={disabled} loading={loading} />}
						displayErrorInAlert
						disabled={loading}
					>
						<NameInputWrapper disabled={loading} />
					</StripeCreditCardLayout>
				</div>
			</div>
		</div>
	);
};
